module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/39VUAn/tc-custom/9781507188644.jpg?1692614730474",
      "alt": "This image is the cover for the book Um Rapaz para o Monstro de Tentáculos"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Um Rapaz para o Monstro de Tentáculos\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Era o décimo oitavo aniversário de Ian, e tudo o que ele queria era ir com o pai para a cidade do castelo de Gabbs. Infelizmente, o sacrifício anual ao jinn, um horrível monstro de tentáculos, aconteceria naquela noite, adiando sua busca para buscar uma assembleia com o rei. Forçado a ficar em uma pousada até que o ritual acabasse, Ian deixou seu pai para explorar a cidade. Pouco ele sabia que o jinn estaria muito mais interessado nele do que os sacrifícios que tinham sido apresentados."), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kyler Matthew, José Roberto Rosado Corrêa Filho\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Kyler Matthew escreve romances sensuais eróticos gays e romances eróticos em uma variedade de subgêneros com foco em paranormal e ficção científica."), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Babelcube\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0